import { paymentsConfig, createSelectOptionsForCardForm, getCardInfo, VirtualForm } from './paymentsUtils';
import { loadMercadoPago } from '@mercadopago/sdk-js';

const loadSecurity = () => {
  return new Promise((resolve, reject) => {
    const src = "https://www.mercadopago.com/v2/security.js";
    const checkScript = document.querySelector(`script[src^='${src}']`);
    if (!checkScript) {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => {
        console.warn("Falha ao carregar script ".src);
        reject(false);
      }
      document.head.appendChild(script);
    }
  });
}
loadSecurity();
/**
 * Objecto do Mercado Pago
 */
let mp;
// Carrega o script do Mercado Pago
loadMercadoPago()
  .then(r => {
    mp = new MercadoPago(paymentsConfig.getByGateway(20).sdk_public_key, {
      locale: 'pt-BR',
      advancedFraudPrevention: false
    });
  });

export const setInstallments = (form) => {
  form.querySelector("select#cardInstallments")?.setAttribute("disabled", true);
  const parcelsOption = Array.from(form.querySelectorAll("select#cardInstallments option"));
  let maxParcels = 12;
  if (parcelsOption) {
    maxParcels = parcelsOption[parcelsOption.length - 1]?.value?.split("_")[0];
    maxParcels = parseInt(maxParcels);
  }
  form.querySelector("input#cardNumber")?.addEventListener('blur', () => {
    const { cardNumber } = getCardInfo(form);
    if (window.TransactionInfo && window.TransactionInfo.total && cardNumber.length >= 6) {
      const amount = window.TransactionInfo.total.replace('.', '').replace(',', '.');
      mp.getInstallments({ amount, bin: cardNumber })
        .then(([installmentsResponse]) => {
          const select = form.querySelector("select#cardInstallments");
          select.innerHTML = "";
          select.removeAttribute("disabled");
          createSelectOptionsForCardForm(select, 0, 0, '');
          for(const { installments, total_amount, recommended_message } of installmentsResponse.payer_costs) {
            if (maxParcels > 0 && installments > maxParcels) break;
            const installmentRate = (total_amount - parseFloat(amount)).toFixed(2);
            createSelectOptionsForCardForm(select, installments, installmentRate, recommended_message);
          }
          const paymentMethodInput = form.querySelector("input#payment_method"); 
          if (paymentMethodInput) {
            paymentMethodInput.value = installmentsResponse.payment_method_id;
          }
        });
    }
  });
}


export const submitForm = (form) => {
  const { cardholderName, cardNumber, securityCode, cardExpirationMonth, cardExpirationYear } = getCardInfo(form);
  if (
    !cardholderName || !cardNumber || !securityCode || !cardExpirationMonth || !cardExpirationYear
  ) {
    return Promise.reject("É preciso preencher todas as informações do cartão.");
  }
  const tokenInput = document.createElement("input");
  return mp.createCardToken({
    cardNumber,
    cardholderName,
    cardExpirationMonth,
    cardExpirationYear,
    securityCode,
  }).then(result => {
    if (!result || !result.id) {
      throw new Error("Falha ao gerar o token, recarregue a página e tente novamente");
    }
    tokenInput.type = 'hidden';
    tokenInput.name = "token";
    tokenInput.value = result.id;
    form.appendChild(tokenInput);
  });
}
/**
 * Formulários de front-end prontos para serem usados no mercado pago
 * Inicia o formulário.
 * 
 * @see https://github.com/mercadopago/sdk-js/blob/main/docs/bricks/payment.md
 * https://www.mercadopago.com.br/developers/pt/live-demo/card-payment-brick
 * https://www.mercadopago.com.br/developers/pt/live-demo/payment-brick
 * 
 * @param {HTMLElement} container Container que é carregado o "Brick"
 */
export const renderBrick = (container) => {
  if (window.cardPaymentBrickController) {
    window.cardPaymentBrickController.unmount();
  }
  const total = parseFloat(window.TransactionInfo.total.replace('.', '').replace(',', '.'));

  const bricksBuilder = mp.bricks();
  const renderCardPaymentBrick = async (bricksBuilder) => {
    const settings = {
      initialization: {
        amount: total, // valor total a ser pago
      },
      customization: {
        visual: {
          hideFormTitle: true,
          style: {
            theme: 'default', // | 'dark' | 'bootstrap' | 'flat'
            customVariables: {
            },
          },
        },
        paymentMethods: {
          types: {
            excluded: ['debit_card']
          },
          creditCard: 'all',
          minInstallments: 1,
          maxInstallments: 10,
        },
      },
      callbacks: {
        onReady: () => {
          // callback chamado quando o Brick estiver pronto
        },
        onSubmit: (cardFormData) => {
          const paymentId = container.getAttribute('data-paymentId');
          const gatewayId = container.getAttribute('data-gatewayId');
          const paymentClass = container.getAttribute('data-paymentClass');
          const form = new VirtualForm('form-payment-mercadopago', '', 'POST');
          form.addInput('checkout', '1');
          form.addInput('nparcels', '1');
          form.addInput('payment_type', paymentClass);
          form.addInput('payment_method', cardFormData.payment_method_id);
          form.addInput('nparcels', `${cardFormData.installments}_${cardFormData.transaction_amount - total}`);
          form.addInput('paymentId', paymentId);
          form.addInput('gateway', gatewayId);
          form.addInput('deviceId', MP_DEVICE_SESSION_ID);
          form.addInput('token', cardFormData.token);
          container.appendChild(form.getForm());
          form.getForm().submit();
        },
        onError: (error) => {
          console.error(error);
          // callback chamado para todos os casos de erro do Brick
        },
      },
    };
    window.cardPaymentBrickController = await bricksBuilder.create('cardPayment', 'paymentBrick_container', settings);
  };

  renderCardPaymentBrick(bricksBuilder);
}